module.exports = __webpack_public_path__ + "img/09.363cda8c.jpg";